exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-summary {\r\n  display: -ms-grid;\r\n  display: grid;\r\n  -ms-grid-columns: (minmax(0, 1fr))[1];\r\n      grid-template-columns: repeat(1, minmax(0, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.ai-summary__card {\r\n  padding: 16px;\r\n  border: 1px solid var(--color-border, #dee2e6);\r\n  border-radius: 8px;\r\n  background: var(--color-surface, #fff);\r\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);\r\n}\r\n\r\n.ai-summary__label {\r\n  margin: 0 0 8px;\r\n  color: var(--color-text-muted, #6c757d);\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.ai-summary__value {\r\n  margin: 0;\r\n  color: var(--color-text, #212529);\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .ai-summary {\r\n    -ms-grid-columns: (minmax(0, 1fr))[3];\r\n        grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/ai-statistics-summary/ai-statistics-summary.component.css
// module id = ../../../../../src/app/content-page/common/skill-learning/components/admin/ai-statistics-summary/ai-statistics-summary.component.css
// module chunks = main